import { JwtAxios } from '@/packaging';
export const tossShoppingApi = {
  async GetTossShoppingApiTemplate(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetTossShoppingApiTemplate?marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  async SetTossShoppingApiTemplate(model) {
    const responseModel = await JwtAxios.post(`/Template/Market/SetTossShoppingApiTemplate`, model);
    return responseModel;
  },
  async SetTossShoppingApi(body) {
    const responseModel = await JwtAxios.post('/Template/Market/SetTossShoppingApi', body);
    return responseModel;
  }
};
